import { FC } from 'react';

const NotFoundPage: FC = () => {
    return (
        <>
            <hr />
            <h1>NotFoundPage</h1>
            <hr />
        </>
    );
};

export default NotFoundPage;
